import { Button, Box, CardActionArea, CardActions, CardContent, CardMedia, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { ReactComponent as CheckCircleOutline } from '../assets/check2-circle.svg';
import { useNavigate } from "react-router-dom";
import { paths } from "../paths";
import { useContext } from "react";
import LayoutContext from "../components/layout/layout-context";
import ReferalClientEnrolmentForm from "../components/referral-client-enrolment/referral-client-enrolment-form";
import { CustomerRoleName, useRoleStore } from "../store/ProfileStore";
import Footer from "../components/footer";

const  UpgradeEnrolment = () => {

    const navigate = useNavigate();
    const { enrolmentSource } = useContext(LayoutContext);
    const { customerRole } = useRoleStore();

    const onClickHandler = () => {
        if(customerRole === CustomerRoleName.TaxReliefGraduatedCustomer || customerRole === CustomerRoleName.NonTaxPrepReferredCustomer){
            navigate(paths.dashboard.graduatedResEnrollment);
        }else {
            navigate(paths.dashboard.protectionPlanEnrollment);
        }
    }

    return (
        <>
        {(enrolmentSource === 'Referral' && customerRole !== CustomerRoleName.NonTaxPrepReferredCustomer)? <ReferalClientEnrolmentForm />:
        <>
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              component="img"
              src="/assets/BG-SmilingFaces.png"
              alt="Smiling Faces Background"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                zIndex: 0,
              }}
            />
            <Box
              sx={{
                position: 'relative',
                zIndex: 1,
                p: 4,
                flex: '1 0 auto',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                Upgrade to unlock <br /> full protection.
              </Typography>

              <Typography variant="body1" className="mt-3">
                Get Optima’s best-in-class protection<br />plus <b>Lifetime Audit Defense.*</b>
              </Typography>

              <Typography variant="body2" className="mt-3">
                <CheckCircleOutline className="me-1"/> Lifetime Audit Defense*
              </Typography>
              <Typography variant="body2" className="mt-1">
                <CheckCircleOutline className="me-1"/> Professional Tax Preparation Services
              </Typography>
              <Typography variant="body2" className="mt-1">
                <CheckCircleOutline className="me-1"/> Discounted Tax Resolution Services
              </Typography>
              <Typography variant="body2" className="mt-1">
                <CheckCircleOutline className="me-1"/> Tax ID Fraud Remediation
              </Typography>
              <Typography variant="body2" className="mt-1">
                <CheckCircleOutline className="me-1"/> And More!
              </Typography>
              <CardActions>
                  <Button className="plan-fill-button mt-3" onClick={onClickHandler}>
                    Upgrade to Unlock Access <ArrowForward />
                  </Button>
              </CardActions>

              <Typography className="fs-10px">
                * Lifetime dependent on being active customer of any Optima Tax Shield Plan.<br />Please review Protection Agreement for details and limitations.
              </Typography>
            </Box>

            <Box sx={{ zIndex: 1, flexShrink: 0 }}>
              <Footer />
            </Box>
        </Box>
        </>
        }
        </>
    )
}

export default UpgradeEnrolment;